module.exports = __webpack_public_path__ + "static/media/halloween-texture.d73d0725.png";